import React, {useState} from 'react';
import {Step, StepLabel, Stepper} from '@material-ui/core';
import {useLoggedInUser} from './useLoggedInUser';
import {generateCatalogInfoYaml} from './generateCatalogInfo';
import {emptyFormValues, RegisterWizardFormValues} from './types';
import {DetailsFormStep, DetailsCompletion} from './steps/DetailsFormStep';
import {PreviewYamlStep} from './steps/PreviewYamlStep';
import {OpenPrStep} from './steps/OpenPrStep';
import {RegisterStep} from './steps/RegisterStep';

const STEP_LABELS = ['Details', 'Review catalog-info.yaml', 'Open pull request', 'Register'];

export const RegisterWizard = () => {
  const loggedInUser = useLoggedInUser();
  const [activeStep, setActiveStep] = useState(0);
  const [formValues, setFormValues] = useState<RegisterWizardFormValues>(emptyFormValues);
  const [yaml, setYaml] = useState('');
  const [registeredBy, setRegisteredBy] = useState('');
  const [hasPermission, setHasPermission] = useState(false);
  const [mainBranch, setMainBranch] = useState('');

  const handleDetailsNext = (values: RegisterWizardFormValues, completion: DetailsCompletion) => {
    const registeredByValue = loggedInUser?.userEntityRef ?? loggedInUser?.email ?? 'unknown';
    setFormValues(values);
    setRegisteredBy(registeredByValue);
    setYaml(generateCatalogInfoYaml(values, registeredByValue));
    setHasPermission(completion.hasPermission);
    setMainBranch(completion.mainBranch);
    setActiveStep(1);
  };

  const handlePrStepNext = (branch: string) => {
    setMainBranch(branch);
    setActiveStep(3);
  };

  return (
    <div>
      <Stepper activeStep={activeStep} alternativeLabel style={{marginBottom: 24}}>
        {STEP_LABELS.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {activeStep === 0 && (
        <DetailsFormStep
          initialValues={formValues}
          loggedInUser={loggedInUser}
          onNext={handleDetailsNext}
        />
      )}
      {activeStep === 1 && (
        <PreviewYamlStep
          yaml={yaml}
          hasPermission={hasPermission}
          onChange={setYaml}
          onBack={() => setActiveStep(0)}
          onNext={() => setActiveStep(2)}
        />
      )}
      {activeStep === 2 && (
        <OpenPrStep
          repoUrl={formValues.repoUrl}
          yaml={yaml}
          registeredBy={registeredBy}
          hasPermission={hasPermission}
          mainBranch={mainBranch}
          onBack={() => setActiveStep(1)}
          onNext={handlePrStepNext}
        />
      )}
      {activeStep === 3 && (
        <RegisterStep
          repoUrl={formValues.repoUrl}
          mainBranch={mainBranch}
          onBack={() => setActiveStep(2)}
        />
      )}
    </div>
  );
};
